import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTarget32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconTarget32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M26.699 1.684 26.187.149l-1.144 1.144-3.536 3.535-.378.379.105.525.133.664A10.95 10.95 0 0 0 16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11a10.95 10.95 0 0 0-1.4-5.373l.661.132.525.105.378-.379L30.7 6.95l1.144-1.144-1.535-.512L27.6 4.39zm-2.92 6.539 2.35.47L28.14 6.68l-1.647-.55-.474-.158-.158-.474-.549-1.647L23.3 5.864l.47 2.35zM25 16a9 9 0 1 1-9-9c2.125 0 4.078.736 5.618 1.968l-1.426 1.425a7 7 0 1 0 1.414 1.414l1.426-1.425A8.96 8.96 0 0 1 25 16m-9-5c1.02 0 1.967.305 2.757.828l-1.464 1.464a3 3 0 1 0 1.414 1.414l1.465-1.463A5 5 0 1 1 16 11m0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTarget32);
